/* 🤖 this file was generated by svg-to-ts */
export const matIconBrightness3: {
  name: 'brightness-3';
  data: string;
} = {
  name: 'brightness-3',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12.7 4.91A8 8 0 0 1 17 12a8 8 0 0 1-4.3 7.09c1.46-2 2.3-4.46 2.3-7.09s-.84-5.09-2.3-7.09M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54s-2.94 8.27-7 9.54c.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"/></svg>`
};
